// Converts a human readable text like "This is a text", "ThisIsAText" or "thisIsAText" to a string in the Kebab case format, i.e., "this-is-a-text"
export const convertTextToKebabCase = (value: string): string => {
  return value
    .trim()
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .split(/\s+/)
    .map(word => word.toLowerCase())
    .join('-');
}
